import React, { Component, Fragment } from "react";
import fetch from "isomorphic-fetch";
import { saveAs } from "file-saver";
import {
	Table,
	Row,
	Button,
	Icon,
	Form,
	Popconfirm,
	Spin,
	Divider,
	Tooltip,
	Dropdown,
	Menu
} from "antd";
import moment from "moment";
import { ModuleMap } from "common/modules";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";
import RankerXLink from "components/RankerXLink";
import AddEditLinkSetDialog from "./AddEditLinkSetDialog";

const FormItem = Form.Item;

@inject("rootStore")
@observer
class LinkSets extends Component {
	showAddLinkSetDialog = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		campaignStore.showAddLinkSetDialog();
	};

	showRenameLinkSetDialog = e => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		campaignStore.showRenameLinkSetDialog({
			id: e.currentTarget.dataset.id,
			name: e.currentTarget.dataset.name
		});
	};

	columns = [
		{
			title: "ID",
			dataIndex: "id",
			width: 120,
			defaultSortOrder: "descend",
			sorter: (a, b) => a.id - b.id
		},
		{
			title: "Name",
			dataIndex: "name",
			sorter: (a, b) => (a.name > b.name ? 1 : -1),
			render: (text, record) => {
				return (
					<RankerXLink
						routeName="links"
						params={{ id: record.id.toString() }}
					>
						{text}
					</RankerXLink>
				);
			}
		},
		{
			title: "Count",
			dataIndex: "count"
		},
		{
			title: "Action",
			render: (text, record) => {
				let linkSet = record;
				let exportLinkSet =
					"/action/export/url_list_only/" + linkSet.id;
				return (
					<span>
						<Tooltip title="Rename">
							<a
								data-name={linkSet.name}
								data-id={linkSet.id}
								onClick={this.showRenameLinkSetDialog}
							>
								<Icon type="edit" />
							</a>
						</Tooltip>
						<Divider type="vertical" />
						<Tooltip title="Download Backlinks">
							<a type="primary" href={exportLinkSet}>
								<Icon type="download" />
							</a>
						</Tooltip>
					</span>
				);
			}
		}
	];

	deleteLinkSets = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		campaignStore.remoteDeleteLinkSets();
	};

	downloadLinkSets = ({ key }) => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		let ids = campaignStore.ui.selectedLinkSetKeys.slice();
		fetch("/action/export/url_lists/" + campaignStore.campaign.id, {
			method: "POST",
			body: JSON.stringify({
				ids: ids,
				fullInfo: key == "urlsOnly" ? false : true
			}),
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		}).then(response => {
			let filename = campaignStore.campaign.name + key == "urlsOnly" ? "_urls.txt" : "_urls.csv";
			let disposition = response.headers.get("Content-Disposition");
			if (disposition && disposition.indexOf("attachment") !== -1) {
				var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
				var matches = filenameRegex.exec(disposition);
				if (matches != null && matches[1]) {
					filename = matches[1].replace(/['"]/g, "");
				}
			}
			response.blob().then(data => {
				saveAs(data, filename);
			});
		});
	};

	render() {
		const {
			rootStore: { campaignStore }
		} = this.props;
		const selectedRowKeys = campaignStore.ui.selectedLinkSetKeys;

		const rowSelection = {
			selectedRowKeys: selectedRowKeys,
			onChange: (selectedRowKeys, selectedRows) => {
				campaignStore.selectLinkSets(selectedRowKeys);
			}
		};

		const spinning = campaignStore.ui.deletingLinkSets == true;

		let downloadLinkSetsMenu = (
			<Menu
				onClick={this.downloadLinkSets}
				disabled={selectedRowKeys.length == 0}
			>
				<Menu.Item key="urlsOnly">URLs Only</Menu.Item>
				<Menu.Item key="fullInfo">Full Info</Menu.Item>
			</Menu>
		);

		return (
			<Spin spinning={spinning}>
				<Row>
					<Form layout="inline" style={{ marginBottom: 8 }}>
						<FormItem>
							<Button
								type="primary"
								onClick={this.showAddLinkSetDialog}
							>
								<Icon type="plus-square-o" />
							</Button>
						</FormItem>
						<FormItem>
							<Popconfirm
								title="Do you want to delete the selected link sets?"
								placement="bottom"
								onConfirm={this.deleteLinkSets}
							>
								<Button
									type="primary"
									disabled={selectedRowKeys.length == 0}
								>
									<Icon type="delete" />
								</Button>
							</Popconfirm>
						</FormItem>
						<FormItem>
							<Tooltip title="Download">
								<Dropdown overlay={downloadLinkSetsMenu} disabled={selectedRowKeys.length == 0}>
									<Button type="primary">
										<Icon type="download" />
									</Button>
								</Dropdown>

								{/* <Button
									type="primary"
									disabled={selectedRowKeys.length == 0}
									onClick={this.downloadLinkSets}
								>
									<Icon type="download" />
								</Button> */}
							</Tooltip>
						</FormItem>
					</Form>
				</Row>
				<Row>
					<Table
						rowKey="id"
						columns={this.columns}
						rowSelection={rowSelection}
						dataSource={this.props.linkSets}
						pagination={{
							pageSize: 100
						}}
					/>
				</Row>
			</Spin>
		);
	}
}

@inject("rootStore")
@observer
export default class LinkSetsTab extends Component {
	render() {
		const {
			rootStore: { campaignStore }
		} = this.props;

		const linkSets = toJS(campaignStore.urlLists);

		return (
			<Fragment>
				<AddEditLinkSetDialog />
				<LinkSets linkSets={linkSets} />
			</Fragment>
		);
	}
}
